module.exports = __webpack_public_path__ + "img/cards-int.6a662116.svg";